import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import AlertSettingPermission from './AlertSettingPermission';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function SettingEditPermissionForm({ props, argsAll }) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const [editPermissionList, setEditPermissionList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const knowledgeTicketEditPermissions = Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT;

    let selectedEditPermissionsByViewPermissions = [
        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.CREATOR_ONLY,
        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.IN_PROJECT,
        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.BY_VIEW_PERMISSION
    ];

    const onChangeSelectedEditPermission = (_, value) => {
        argsAll.setSelectedEditPermissions(value);
        if (value.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    const filterSugguestionEditOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option}`
    });

    const handleDeleteEditPermission = selectedOption => {
        let newSelectEditPermissions = argsAll.selectedEditPermissions.filter(option => {
            return option !== selectedOption;
        });
        argsAll.setSelectedEditPermissions([...newSelectEditPermissions]);
        if (argsAll.formEdit) argsAll.setIsChangeData(true);
        if (newSelectEditPermissions.length === 0) argsAll.setIsChangeData(false);
    };

    const setEditPermissionByViewPermission = selectedViewPermissions => {
        if (
            selectedViewPermissions?.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.PUBLIC)
        ) {
            const viewPermissions = selectedViewPermissions.filter(
                item => item !== Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.PUBLIC
            );

            selectedEditPermissionsByViewPermissions.push(
                ...viewPermissions,
                Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.IN_ORG,
                Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PUBLIC,
                Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.B2B_CUSTOMER,
                Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.B2B_SUPPORT
            );
        } else {
            selectedEditPermissionsByViewPermissions.push(...selectedViewPermissions);
        }
        let newSelectEditPermissionsByViewPermissions = _.uniq(
            selectedEditPermissionsByViewPermissions
        );
        setEditPermissionList(newSelectEditPermissionsByViewPermissions);
    };

    useEffect(() => {
        if (argsAll.formEdit) {
            const selectedEditPermissions = argsAll.formEdit.editPermission?.map(
                key => knowledgeTicketEditPermissions[key]
            );
            if (Utils.isEmptyArray(selectedEditPermissions)) {
                argsAll.setSelectedEditPermissions([]);
            } else {
                argsAll.setSelectedEditPermissions([...selectedEditPermissions]);
            }

            const selectedViewPermissions = argsAll.formEdit.viewPermission?.map(
                key => Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT[key]
            );
            setEditPermissionByViewPermission(selectedViewPermissions);
        } else {
            setEditPermissionList(selectedEditPermissionsByViewPermissions);
        }
    }, []);

    useEffect(() => {
        if (!argsAll.isViewPermissionSelected) return;

        if (argsAll.selectedEditPermissions?.includes(knowledgeTicketEditPermissions.BY_VIEW_PERMISSION)) {
            argsAll.setSelectedEditPermissions([
                knowledgeTicketEditPermissions.CREATOR_ONLY,
                knowledgeTicketEditPermissions.PROJECT_MANAGER,
                knowledgeTicketEditPermissions.BY_VIEW_PERMISSION
            ]);
        } else {
            argsAll.setSelectedEditPermissions([
                knowledgeTicketEditPermissions.CREATOR_ONLY,
                knowledgeTicketEditPermissions.PROJECT_MANAGER
            ]);
        }

        setEditPermissionByViewPermission(argsAll.selectedViewPermissions);
    }, [argsAll.selectedViewPermissions]);

    return (
        <>
            <div className="lstCreateForm padding-0">
                <label className="share-option-text">{tr('基本編集権限')}</label>
                <div className="share-option-control">
                    <Autocomplete
                        className="search-option-tag-content"
                        multiple
                        filterSelectedOptions
                        filterOptions={filterSugguestionEditOption}
                        getOptionLabel={option => tr(option)}
                        options={editPermissionList}
                        value={argsAll.selectedEditPermissions}
                        onChange={onChangeSelectedEditPermission}
                        disabled={argsAll.isFormReadOnly}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant="outlined"
                                className="form-control"
                                error={argsAll.selectedEditPermissions.length === 0}
                                helperText={
                                    argsAll.selectedEditPermissions.length === 0
                                        ? trI18n('COMMSG014')
                                        : ''
                                }
                                onKeyDown={event => {
                                    if (event.key === 'Backspace') event.stopPropagation();
                                }}
                            />
                        )}
                        renderTags={valueTag => {
                            return valueTag.map((selecedOption, index) => {
                                return argsAll.isFormReadOnly ||
                                    [
                                        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.CREATOR_ONLY,
                                        Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT
                                            .PROJECT_MANAGER
                                    ].includes(selecedOption) ? (
                                    <Chip
                                        label={tr(selecedOption)}
                                        className="MuiChip-root setting-title"
                                        deleteIcon={true}
                                    />
                                ) : (
                                    <Chip
                                        label={tr(selecedOption)}
                                        className="MuiChip-root setting-title"
                                        onDelete={e => {
                                            valueTag.length > 1
                                                ? handleDeleteEditPermission(selecedOption)
                                                : setIsAlertOpen(true);
                                        }}
                                    />
                                );
                            });
                        }}
                        ListboxProps={{
                            style: {
                                maxHeight: 376,
                                overflow: 'auto',
                                overflowX: 'hidden'
                            }
                        }}
                        noOptionsText={trI18n('COMMSG001')}
                    />
                    <AlertSettingPermission isOpen={isAlertOpen} setIsOpen={setIsAlertOpen} />
                </div>
            </div>
        </>
    );
}
